// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--f70fd";
export var main = "Layout-module--main--8841c";
export var textStyleLargeTitle = "Layout-module--text-style-large-title--9a96a";
export var textStyleLargestTitle = "Layout-module--text-style-largest-title--5fd9c";
export var textStyleMediumTitle = "Layout-module--text-style-medium-title--89f36";
export var textStyleSmallTitle = "Layout-module--text-style-small-title--ca6f5";